module.exports = __webpack_public_path__ + "img/greed.b3ebf2cd.png";